export default __webpack_public_path__ + "static/media/banner7.ddf3fa05.jpg";